export default __webpack_public_path__ + "static/media/Cbs.6702c1e8.svg";